import type { Asset, Category } from '@schibsted-svp/svp-api-types';

export const getCategoryAgeLimit = ({
  ageLimit = null,
  isSeries,
}: Category) => {
  if (ageLimit === null || !isSeries) {
    return null;
  }
  return ageLimit;
};

export const getAssetAgeLimit = (
  asset: Pick<Asset, 'category' | 'additional' | 'series'>
) => {
  const { ageLimit = null } = asset.additional?.settings ?? {};
  if (ageLimit !== null) {
    return ageLimit;
  }

  const categoryAgeLimit = getCategoryAgeLimit(asset.category);
  if (asset.series && categoryAgeLimit !== undefined) {
    return categoryAgeLimit;
  }

  return null;
};
